var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card p-1 mb-0" }, [
    _c("div", { staticClass: "card-content pb-3" }, [
      _c("div", { staticClass: "d-flex" }, [
        _c("div", [
          _c("a", { attrs: { href: "/member/job/" + _vm.job.slug } }, [
            _c("h5", { staticClass: "text-bold-600" }, [
              _vm._v(_vm._s(_vm.job.title)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "card-text primary text-bold-700 mb-05 d-block" },
              [
                _c("i", { staticClass: "feather icon-clock" }),
                _vm._v(" " + _vm._s(_vm.job.employment_type)),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "font-small-2 text-light d-block" }, [
              _c("i", { staticClass: "feather icon-briefcase" }),
              _vm._v("  " + _vm._s(_vm.job.organisation_name)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "font-small-2 text-light d-block" }, [
              _c("i", { staticClass: "feather icon-map-pin" }),
              _vm._v(" " + _vm._s(_vm.job.position_location)),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ml-auto pl-05" }, [
          _c("a", { attrs: { href: "/member/job/" + _vm.job.slug } }, [
            _c("img", {
              attrs: {
                src:
                  _vm.job.organisation_logo !== null
                    ? _vm.job.organisation_logo.url
                    : "/images/logo.png",
                width: "75",
                alt: "Logo",
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.service_settings.description_display
        ? _c("div", {
            staticClass: "card-content job-description font-small-4 mt-1",
            domProps: { innerHTML: _vm._s(_vm.description) },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.job.disabled === 1
      ? _c("div", { staticClass: "mb-3" }, [
          _c(
            "span",
            {
              staticClass:
                "badge badge-pill bg-danger mb-05 text-bold-700 font-small-2 ",
            },
            [
              _c("i", { staticClass: "feather icon-alert-circle" }),
              _vm._v(" " + _vm._s(_vm.__("job.job_inactive"))),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-bottom d-flex align-items-center" }, [
      _vm.job.hide_salary === 0
        ? _c("div", { staticClass: "pt-1" }, [
            _c(
              "span",
              { staticClass: "font-small-2 text-dark text-bold-700 d-block" },
              [_vm._v(" " + _vm._s(_vm.job.custom_salary))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto pt-1 d-flex align-items-center" }, [
        _c("a", { attrs: { href: "/member/job/" + _vm.job.slug } }, [
          _c(
            "button",
            {
              staticClass: "btn-sm btn-flat-light",
              staticStyle: { border: "none" },
            },
            [
              _vm._v(_vm._s(_vm.__("globals.view")) + " "),
              _c("i", { staticClass: "feather icon-chevron-right" }),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.confirmed_user === true && _vm.job.external_link == null
          ? _c(
              "a",
              {
                staticClass: "btn-sm btn-primary waves-effect waves-light",
                staticStyle: { border: "none" },
                attrs: { href: "/member/job-applies?apply=" + _vm.job.slug },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__("job.form.buttons.apply")) +
                    "\n                "
                ),
                _c("i", { staticClass: "fas fa-user-check" }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }